import { OrderBy, SortBy } from '../enums/sorting';

export class LotFilter {
  from?: number;
  to?: number;
  storeId?: string | null;
  productId?: string | null;
  query?: string | null;
  sort?: SortBy | null; // product_name|expired_at|created_at
  order?: OrderBy | null; // asc, desc
  start?: number | null;
  limit?: number | null;

  // helper
  currentPage = 1;
  itemsPerPage = 20;

  constructor(init?: Partial<LotFilter>) {
    Object.assign(this, init);
  }

  getQuery(): string {
    let start = this.start;
    let limit = this.limit;

    if (start == undefined && limit == undefined) {
      start = (this.currentPage - 1) * this.itemsPerPage;
      limit = this.itemsPerPage;
    }

    let q = '';
    q += this.storeId ? '&store_id=' + this.storeId : '';
    q += this.productId ? '&product_id=' + this.productId : '';
    q += this.from ? '&from=' + this.from : '';
    q += this.to ? '&to=' + this.to : '';
    q += this.query ? '&q=' + this.query : '';
    q += this.sort ? '&sort=' + this.sort : '';
    q += this.order ? '&order=' + this.order : '';
    q += start ? '&start=' + start : '';
    q += limit ? '&limit=' + limit : '';
    q = q ? '?' + q.substring(1) : '';
    return q;
  }
}
